module.exports = __webpack_public_path__ + "img/history_timeline_5.b42f4056.png";